import { render, staticRenderFns } from "./ModalGroupTypeVariantEdit.vue?vue&type=template&id=53eb7010&scoped=true"
import script from "./ModalGroupTypeVariantEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupTypeVariantEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupTypeVariantEdit.vue?vue&type=style&index=0&id=53eb7010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb7010",
  null
  
)

export default component.exports